const hulkLoad = setInterval(function(){
    if (typeof is_draft_order === 'boolean' && document.readyState === 'complete' && hulkapps || typeof hulkapps === 'undefined'){
        clearInterval(hulkLoad);
        document.querySelector('.hulk-submit').removeAttribute('disabled');
        document.querySelector('.hulk-submit').classList.remove('hulk-submit');
    }
},100)
